import { TempleAnalyticsActionTypes } from './constants';

export type TempleAnalyticsActionType = {
    type:
        | TempleAnalyticsActionTypes.API_RESPONSE_SUCCESS
        | TempleAnalyticsActionTypes.API_RESPONSE_ERROR
        | TempleAnalyticsActionTypes.GET_ADMIN_DASHBOARD
        | TempleAnalyticsActionTypes.RESET;

    payload: {} | string;
};

// Common Success
export const templeAnalyticsApiResponseSuccess = (
    actionType: string,
    data: any
): TempleAnalyticsActionType => ({
    type: TempleAnalyticsActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});

// Common Error
export const templeAnalyticsApiResponseError = (
    actionType: string,
    error: string
): TempleAnalyticsActionType => ({
    type: TempleAnalyticsActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

// Get Admin Dashboard
export const getAdminDashboardAction = (params: any): TempleAnalyticsActionType => ({
    type: TempleAnalyticsActionTypes.GET_ADMIN_DASHBOARD,
    payload: params,
});

// Reset
export const resetTempleAnalyticsState = (): TempleAnalyticsActionType => ({
    type: TempleAnalyticsActionTypes.RESET,
    payload: {},
});